<h5 class="title mb-4 text-primary">{{'sessao_iv'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_28')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_28_{{item.id}}"
                            #mdc_28="ngModel" name="mdc_28" [(ngModel)]="mdcService.formData.mdc_28"
                            value="{{item.value}}" [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_28_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_29'], mdcService.formData.mdc_28! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_29')}}<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_29="ngModel" name="mdc_29" [(ngModel)]="mdcService.formData.mdc_29"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc29options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_29_outro'], mdcService.formData.mdc_29! == 11, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_29_outro="ngModel" name="mdc_29_outro"
                [(ngModel)]="mdcService.formData.mdc_29_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_30')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center">
                <li *ngFor="let opcao of mdcService.mdc30options">
                    <div class="custom-control custom-control-sm custom-checkbox custom-control-pro">
                        <input type="checkbox" class="custom-control-input" [value]="opcao.id"
                            [id]="'mdc_30_' + opcao.id" name="mdc_30" [(ngModel)]="opcao.isSelected"
                            (change)="mdcService.onMultipliClickWithUniqueIdOption(opcao, 'mdc_30', mdcService.mdc30options, 8)"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required
                            (ngModelChange)="mdcService.onCheckboxChange(opcao, 'mdc_30', 'mdc_30_outro', 7)">
                        <label class="custom-control-label" [for]="'mdc_30_' + opcao.id">
                            {{ opcao.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_30_outro'], this.mdcService.formData.mdc_30 && this.mdcService.formData.mdc_30.includes(7), null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_30_outro="ngModel" name="mdc_30_outro"
                [(ngModel)]="mdcService.formData.mdc_30_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_31')}}<span class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdcSimNaoNaoSabeOptions">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input" id="mdc_31_{{item.id}}" #mdc_31="ngModel"
                            name="mdc_31" [(ngModel)]="mdcService.formData.mdc_31" value="{{item.value}}"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_31_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>